var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtlassianDark = function SvgAtlassianDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.121 15.081c-.363-.4-.909-.364-1.163.11l-5.89 11.79c-.217.473.11 1.019.619 1.019h8.18a.67.67 0 0 0 .617-.4c1.818-3.64.727-9.207-2.363-12.519M15.447 4.382c-3.271 5.204-3.053 10.99-.908 15.32 2.18 4.331 3.817 7.68 3.962 7.898.11.254.364.4.618.4h8.18c.509 0 .872-.546.618-1.019 0 0-11.016-22.053-11.306-22.599-.218-.51-.873-.51-1.164 0"
  })));
};
export default SvgAtlassianDark;